import React, { useState, useEffect } from 'react';

const News = () => {
  const [news, setNews] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [newNews, setNewNews] = useState({ title: '', content: '' });

  useEffect(() => {
    // Fetch news items
    fetch('/api/news.php')
      .then(response => response.json())
      .then(data => setNews(data))
      .catch(error => console.error('Error fetching news:', error));

    // Check if user is admin
    fetch('/api/check_admin.php')
      .then(response => response.json())
      .then(data => setIsAdmin(data.isAdmin))
      .catch(error => console.error('Error checking admin status:', error));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('/api/news.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newNews),
    })
      .then(response => response.json())
      .then(data => {
        setNews([...news, data]);
        setNewNews({ title: '', content: '' });
      })
      .catch(error => console.error('Error posting news:', error));
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Latest News</h2>
      
      {isAdmin && (
        <form onSubmit={handleSubmit} className="mb-8 bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4">Add News</h3>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
            <input
              type="text"
              value={newNews.title}
              onChange={(e) => setNewNews({ ...newNews, title: e.target.value })}
              className="w-full p-2 border rounded"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Content</label>
            <textarea
              value={newNews.content}
              onChange={(e) => setNewNews({ ...newNews, content: e.target.value })}
              className="w-full p-2 border rounded"
              rows="4"
              required
            />
          </div>
          <button
            type="submit"
            className="bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded"
          >
            Post News
          </button>
        </form>
      )}

      <div className="space-y-4">
        {news.map((item) => (
          <div key={item.id} className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
            <p className="text-gray-600 mb-2">{item.content}</p>
            <p className="text-sm text-gray-500">
              Posted on {new Date(item.created_at).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default News; 